// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"ViewErrors_modalBody__2p-o0","modalFooter":"ViewErrors_modalFooter__3xmMG"};